import React from 'react';
import { Inspector } from '@bynder/design-system';
import ShotItem from 'packages/pages/design/sidebar/shots/ShotItem';
import { type SceneRow } from './utils';
import DynamicElementSelectionRow from './DynamicElementSelectionRow';

type Props = {
    rows: SceneRow[];
    isToolbarDisabled: boolean;
    isLoading: boolean;
    isDisabledByReview: boolean;
};

const SceneRows = ({ rows, isToolbarDisabled, isLoading, isDisabledByReview }: Props) => {
    return rows.map((row, idx) => {
        const isLast = idx === rows.length - 1;
        const shouldRenderDivider = row.kind === 'des-group' && !isLast;

        return (
            <React.Fragment key={`${row.kind}-${row.id}`}>
                {row.kind === 'element' ? (
                    <ShotItem
                        isLast
                        shotElement={row.element}
                        forceRender={row.forceRender}
                        isToolbarDisabled={isToolbarDisabled}
                        isLoading={isLoading}
                        isDisabledByReview={isDisabledByReview}
                    />
                ) : (
                    <DynamicElementSelectionRow
                        row={row}
                        isDisabled={isToolbarDisabled || isLoading || isDisabledByReview}
                    >
                        {!!row.children.length && (
                            <SceneRows
                                rows={row.children}
                                isToolbarDisabled={isToolbarDisabled}
                                isLoading={isLoading}
                                isDisabledByReview={isDisabledByReview}
                            />
                        )}
                    </DynamicElementSelectionRow>
                )}
                {shouldRenderDivider && <Inspector.Divider />}
            </React.Fragment>
        );
    });
};

export default SceneRows;
